export const GOOGLE_PREFERRED_SOURCES_SCRIPT_URL =
  "https://news.google.com/swg/js/v1/publisher.js";

export function shouldLoadGooglePreferredSources(pathname: string) {
  const pathOnly = pathname.split(/[?#]/, 1)[0] || "/";
  const normalized = pathOnly !== "/" ? pathOnly.replace(/\/+$/, "") : "/";

  return normalized === "/" || normalized === "/read" || normalized.startsWith("/read/") || normalized === "/education/free-tradingview-indicators-market-structure";
}
